export const handleGetUsers = (docData) => {
  let usersList = [];

  if (docData?.buyers?.length) {
    usersList = [
      ...usersList,
      ...docData.buyers.map((item) => ({
        ...item,
        userType: "Buyer",
      })),
    ];
  }

  if (docData?.sellers?.length) {
    usersList = [
      ...usersList,
      ...docData.sellers.map((item) => ({
        ...item,
        userType: "Seller",
      })),
    ];
  }

  if (docData?.buyer_brokers?.length) {
    usersList = [
      ...usersList,
      ...docData.buyer_brokers.map((item) => ({
        ...item,
        userType: "Buyer Broker",
      })),
    ];
  }

  if (docData?.seller_brokers?.length) {
    usersList = [
      ...usersList,
      ...docData.seller_brokers.map((item) => ({
        ...item,
        userType: "Seller Broker",
      })),
    ];
  }

  return usersList;
};
